import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_2 = {
  class: "col-sm-4 col-form-label text-capitalize-first",
  for: "payin-balance-limit-enabled"
}
const _hoisted_3 = { class: "col-sm-8" }
const _hoisted_4 = { class: "form-check form-switch d-flex align-items-center" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = {
  key: 1,
  class: "row mt-2"
}
const _hoisted_7 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_8 = { class: "col-sm-8" }
const _hoisted_9 = {
  key: 0,
  class: "text-muted small"
}
const _hoisted_10 = {
  key: 1,
  class: "list-unstyled mb-0"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 2,
  class: "text-muted small mt-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showAdminControls)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.helper.trans('labels.payin_balance_limit_for_trader')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                id: "payin-balance-limit-enabled",
                class: "form-check-input",
                type: "checkbox",
                disabled: !_ctx.canEdit,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.settings.isPayinBalanceLimitEnabled) = $event))
              }, null, 8, _hoisted_5), [
                [_vModelCheckbox, _ctx.settings.isPayinBalanceLimitEnabled]
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.settings.isPayinBalanceLimitActive)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.payin_balance_available_for_payout')), 1),
          _createElementVNode("div", _hoisted_8, [
            (_ctx.balanceEntries.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.payin_balance_empty')), 1))
              : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.balanceEntries, (entry) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: entry.currency,
                      class: "d-flex align-items-center justify-content-between gap-2 mb-1"
                    }, [
                      _createElementVNode("span", null, [
                        _createElementVNode("strong", null, _toDisplayString(entry.currency) + ":", 1),
                        _createTextVNode(" " + _toDisplayString(entry.formattedAmount), 1)
                      ]),
                      (_ctx.canReset)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-outline-danger btn-sm text-capitalize-first flex-shrink-0",
                            onClick: _withModifiers(($event: any) => (_ctx.$emit('reset', entry.currency)), ["prevent"])
                          }, _toDisplayString(_ctx.helper.trans('button.reset')), 9, _hoisted_11))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])),
            (_ctx.settings.balanceResetAt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.helper.trans('labels.payin_balance_reset_at')) + ": " + _toDisplayString(_ctx.formattedResetAt), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}